export default "__VITE_ASSET__eda8879e__"